<ion-content>
  <ion-grid class="constrained-content">
    <ion-row>
      <ion-col size-md="4" size="12" class="settings-title-section">
        <h1>
          <ion-icon name="custom-jsm"></ion-icon>JSM
          {{ projectId ? "Sync" : "Global" }} Settings
        </h1>
        <div class="subtitle" style="opacity: 1">
          <span *ngIf="projectId && jsmEnabled"
            >Configure relay rules for this project to automatically route
            conversations to JSM.</span
          >
          <span *ngIf="!projectId && jsmEnabled"
            >Customize your Jira Service Management integration</span
          >
          <span *ngIf="!jsmEnabled"
            >Connect Jira Service Management to start using this
            integration</span
          >
        </div>
      </ion-col>
      <ion-col size="12" size-md="8" *ngIf="jsmEnabled">
        <!-- Tenant-level: Show JSM Instances -->
        <ion-row *ngIf="!projectId">
          <ion-col size="12">
            <ion-card class="outline-card">
              <ion-card-title class="card-title">
                <h3>JSM Instances</h3>
                <div class="subtitle">
                  Connect multiple JSM instances to your account.
                </div>
              </ion-card-title>

              <ion-card-content>
                <ion-card
                  class="outline-card"
                  style="margin: 10px 0"
                  *ngFor="let instance of connectedInstances"
                >
                  <ion-card-content class="flex-space-between">
                    <div>
                      <ion-label
                        text-wrap
                        style="
                          font-weight: 500;
                          font-size: 1rem;
                          display: flex;
                          align-items: center;
                        "
                      >
                        {{ instance.name }}
                        <ion-badge
                          color="success"
                          *ngIf="instance.isPrimary"
                          style="margin-left: 5px"
                          >Primary</ion-badge
                        >
                      </ion-label>
                      <p
                        style="
                          font-size: 0.75rem;
                          color: var(--ion-color-medium);
                          margin: 5px 0 0 0;
                        "
                      >
                        {{ instance.url }}
                      </p>
                    </div>
                    <div class="flexed-align-center">
                      <ion-button
                        color="danger"
                        fill="clear"
                        (click)="
                          disconnectJsmInstance(
                            instance.credentialId,
                            instance.name
                          )
                        "
                        class="btn-small"
                      >
                        <ion-icon
                          name="close-outline"
                          class="padded-icon"
                        ></ion-icon>
                        Disconnect
                      </ion-button>
                      <ion-button
                        fill="clear"
                        (click)="reconnectJsmInstance(instance.name)"
                        class="btn-small"
                      >
                        <ion-icon
                          name="sync-outline"
                          class="padded-icon"
                        ></ion-icon>
                        Reconnect
                      </ion-button>
                    </div>
                  </ion-card-content>
                </ion-card>

                <div
                  *ngIf="connectedInstances.length === 0"
                  style="padding: 20px; text-align: center; opacity: 0.6"
                >
                  <p>No JSM instances connected yet.</p>
                </div>

                <div style="margin-top: 15px">
                  <ion-button
                    fill="outline"
                    (click)="connectJsmInstance()"
                    class="btn-small"
                  >
                    <ion-icon name="add-outline" class="padded-icon"></ion-icon>
                    Connect JSM Instance
                  </ion-button>
                </div>
              </ion-card-content>
            </ion-card>
            <div class="settings-learn-more">
              <a
                href="https://developer.atlassian.com/cloud/jira/service-desk/rest/intro/"
                target="_blank"
              >
                <ion-icon name="book-outline"></ion-icon>
                Learn more about JSM API configuration
              </a>
            </div>
          </ion-col>
        </ion-row>
        <!-- Project-level: Show Relay Rules -->
        <ion-row *ngIf="projectId">
          <ion-col size="12">
            <app-relay-rules [projectId]="projectId"></app-relay-rules>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer *ngIf="jsmEnabled && !projectId">
  <ion-toolbar class="constrained-content">
    <ion-button
      color="success"
      (click)="save()"
      class="save-button"
      [disabled]="!initialized"
      >Save changes
    </ion-button>
  </ion-toolbar>
</ion-footer>
